/* eslint-disable no-shadow */
enum Actions {
  TOGGLE_MENU_DEVELOPER = "TOGGLE_MENU_DEVELOPER",
}

export default Actions;
